const thirdParty = {
  thirdParty: {
    pageHeader: 'Neuen Nutzer Anlegen',
    clearState: 'Bundesland löschen',
    register: 'Registrieren',
    systemRegistrationSummary: 'Systemregistrierungs-Übersicht',
    registrationProgress: '%{registration_in_progress} In Bearbeitung',
    registrationComplete: '%{registration_complete} Abgeschlossen',
    thirdPartyLogin: 'Melden Sie sich als Seitenbesitzer an, um Ihr PowerDash-Konto zu verwalten',
    thirdPartyInvalidURI:
      'Der angeforderte URL ist ungültig oder die angeforderte Ressource, z. B. ein System, ist nicht vorhanden.'
  }
};

export default thirdParty;
